//export function clearStorageOnClose() {
//    window.addEventListener('beforeunload', function (e) {
//        localStorage.clear();
//        sessionStorage.clear();
//    });

//    return true;
//}

export function clearStorageOnClose() {
    const sessionKey = "activeTabs";
    const refreshKey = "isRefreshing";

    function updateActiveTabs(count) {
        sessionStorage.setItem(sessionKey, count);
    }

    function getActiveTabs() {
        return parseInt(sessionStorage.getItem(sessionKey) || "0", 10);
    }

    // Increase active tab count when a new tab is opened
    updateActiveTabs(getActiveTabs() + 1);

    // Mark as refreshing if `beforeunload` is triggered
    window.addEventListener("beforeunload", () => {
        sessionStorage.setItem(refreshKey, "true");

        // Remove the flag after a short delay (ensures it's reset if the page is truly closed)
        setTimeout(() => sessionStorage.removeItem(refreshKey), 100);
    });

    // When a tab is closed or browser is closed
    window.addEventListener("unload", () => {
        updateActiveTabs(getActiveTabs() - 1);

        // Wait to ensure this is not a refresh
        setTimeout(() => {
            const remainingTabs = getActiveTabs();
            const isRefreshing = sessionStorage.getItem(refreshKey);

            // Only clear storage if it's NOT a refresh and all tabs are closed
            if (remainingTabs <= 0 && !isRefreshing) {
                localStorage.clear();
                sessionStorage.clear();
                navigator.sendBeacon("/api/logout"); // Optional server cleanup
            }
        }, 500); // Slight delay to differentiate between refresh and close
    });

    return true;
}